// add-value.component.ts
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IPicklistFieldsData } from "../../interfaces/administration/picklistFieldsData";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import {
  IPicklistsValuesCreateData,
  IPicklistValuesData,
} from "../../interfaces/administration/picklistValuesData";

@Component({
  selector: "app-add-value",
  templateUrl: "./add-value.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
        margin: 10px 0px 0px 0px;
      }
    `,
  ],
})
export class AddValueComponent implements OnInit {
  @Input() selectedField!: IPicklistFieldsData;
  @Output() valueCreated = new EventEmitter<IPicklistsValuesCreateData>();
  @Output() formClosed = new EventEmitter<void>();

  form: FormGroup;
  isLoading = false;
  validationMessages: string[] = [];
  values: IPicklistValuesData[] = [];

  shouldSeeIsOnPrem: boolean = false;

  constructor(
    private fb: FormBuilder,
    private pickListServie: PicklistService
  ) {
    this.form = this.fb.group({
      valueName: ["", Validators.required],
      isOnPrem: [false],
      parentPicklist: ["-1"],
    });
  }

  ngOnInit(): void {
    if (this.selectedField.parentPicklistFieldsId != null) {
      this.pickListServie
        .getPicklistValues(this.selectedField.parentPicklistFieldsId)
        .subscribe((data) => {
          if (data) {
            this.values = data;
            this.shouldSeeIsOnPrem =
              this.selectedField.name.includes("School Attended");
          }
        });
    }
  }

  onIsOnPremChange(event: any) {
    this.form.patchValue({
      isOnPrem: event.target.checked,
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.validationMessages.push("Value is required.");
      return;
    }

    const inputValues = this.form.value.valueName.trim();
    if (!inputValues) {
      this.validationMessages.push("Value is required.");
      return;
    }

    this.isLoading = true;
    this.validationMessages = [];
    let data: IPicklistsValuesCreateData = {
      value: inputValues,
      isOnPrem: this.form.value.isOnPrem,
      parentId:
        this.form.value.parentPicklist === "-1"
          ? null
          : this.form.value.parentPicklist,
    };

    this.valueCreated.emit(data);
    this.form.reset();
    this.isLoading = false;
  }

  cancel() {
    this.formClosed.emit();
  }
}
